module.exports = __webpack_public_path__ + "static/media/location2.8784ace2.webp";